export function SAVE_POLICY(state, [policy_modal]){
    state.policy_modal = policy_modal
}

export function SAVE_POLICY_PREFERENCES(state, [policy_preferences_modal]){
    state.policy_preferences_modal = policy_preferences_modal
}

export function SAVE_COOKIES(state, [accept_cookies]){
    state.accept_cookies = accept_cookies
    // let ids = []
    // ids.push('UA-53707923-3')

    // if (process.env.ID_GOOGLE_ANALYTICS != '') ids.push(process.env.ID_GOOGLE_ANALYTICS)
    // if (process.env.ID_GOOGLE_ANALYTICS_CLIENT != '') ids.push(process.env.ID_GOOGLE_ANALYTICS_CLIENT)
    // Vue.use(VueAnalytics, {
    //     id: ids,
    //     checkDuplicatedScript: true,
    //     router,
    // })
}

export function SAVE_OPTIONAL_COOKIES(state, [accept_cookies]){
    state.accept_cookies = accept_cookies
}